// src/mockData/receipts.ts

export const RECEIPTS = [
  // Sarah's receipts (4 total, should sum to £23,250)
  { 
    id: 'RCP-001', 
    customerId: 'CUST-001', 
    assignedTo: 'user-001', 
    amount: 5000, 
    remaining: 5000,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-001'
  },
  { 
    id: 'RCP-002', 
    customerId: 'CUST-002', 
    assignedTo: 'user-001', 
    amount: 8250, 
    remaining: 8250,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-002'
  },
  { 
    id: 'RCP-003', 
    customerId: 'CUST-003', 
    assignedTo: 'user-001', 
    amount: 6000, 
    remaining: 6000,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-003'
  },
  { 
    id: 'RCP-004', 
    customerId: 'CUST-001', 
    assignedTo: 'user-001', 
    amount: 4000, 
    remaining: 4000,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-06',
    reference: 'PMT-2026-004'
  },
  
  // Mike Chen's receipts (3 receipts)
  { 
    id: 'RCP-005', 
    customerId: 'CUST-006', 
    assignedTo: 'user-002', 
    amount: 12000, 
    remaining: 12000,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-005'
  },
  { 
    id: 'RCP-006', 
    customerId: 'CUST-007', 
    assignedTo: 'user-002', 
    amount: 8500, 
    remaining: 8500,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-006'
  },
  { 
    id: 'RCP-007', 
    customerId: 'CUST-008', 
    assignedTo: 'user-002', 
    amount: 15000, 
    remaining: 15000,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-007'
  },
  
  // Emily Rodriguez's receipts (4 receipts)
  { 
    id: 'RCP-008', 
    customerId: 'CUST-011', 
    assignedTo: 'user-003', 
    amount: 9800, 
    remaining: 9800,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-008'
  },
  { 
    id: 'RCP-009', 
    customerId: 'CUST-012', 
    assignedTo: 'user-003', 
    amount: 11200, 
    remaining: 11200,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-009'
  },
  { 
    id: 'RCP-010', 
    customerId: 'CUST-013', 
    assignedTo: 'user-003', 
    amount: 7600, 
    remaining: 7600,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-010'
  },
  { 
    id: 'RCP-011', 
    customerId: 'CUST-014', 
    assignedTo: 'user-003', 
    amount: 6400, 
    remaining: 6400,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-06',
    reference: 'PMT-2026-011'
  },
  
  // David Kim's receipts (3 receipts)
  { 
    id: 'RCP-012', 
    customerId: 'CUST-016', 
    assignedTo: 'user-004', 
    amount: 13500, 
    remaining: 13500,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-012'
  },
  { 
    id: 'RCP-013', 
    customerId: 'CUST-017', 
    assignedTo: 'user-004', 
    amount: 10200, 
    remaining: 10200,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-013'
  },
  { 
    id: 'RCP-014', 
    customerId: 'CUST-018', 
    assignedTo: 'user-004', 
    amount: 8900, 
    remaining: 8900,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-014'
  },
  
  // Lisa Anderson's receipts (4 receipts)
  { 
    id: 'RCP-015', 
    customerId: 'CUST-021', 
    assignedTo: 'user-005', 
    amount: 14800, 
    remaining: 14800,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-015'
  },
  { 
    id: 'RCP-016', 
    customerId: 'CUST-022', 
    assignedTo: 'user-005', 
    amount: 11600, 
    remaining: 11600,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-016'
  },
  { 
    id: 'RCP-017', 
    customerId: 'CUST-023', 
    assignedTo: 'user-005', 
    amount: 9200, 
    remaining: 9200,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-017'
  },
  { 
    id: 'RCP-018', 
    customerId: 'CUST-024', 
    assignedTo: 'user-005', 
    amount: 7400, 
    remaining: 7400,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-06',
    reference: 'PMT-2026-018'
  },
  
  // James Wilson's receipts (3 receipts)
  { 
    id: 'RCP-019', 
    customerId: 'CUST-026', 
    assignedTo: 'user-006', 
    amount: 16200, 
    remaining: 16200,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-019'
  },
  { 
    id: 'RCP-020', 
    customerId: 'CUST-027', 
    assignedTo: 'user-006', 
    amount: 12800, 
    remaining: 12800,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-07',
    reference: 'PMT-2026-020'
  },
  { 
    id: 'RCP-021', 
    customerId: 'CUST-028', 
    assignedTo: 'user-006', 
    amount: 10400, 
    remaining: 10400,
    status: 'unallocated' as const, 
    receivedDate: '2026-01-08',
    reference: 'PMT-2026-021'
  }
];
